'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Expand = function Expand(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 13 13' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'title',
        null,
        'Combined Shape'
      ),
      _react2.default.createElement('path', { d: 'M6 6V.5a.5.5 0 1 1 1 0V6h5.5a.5.5 0 1 1 0 1H7v5.5a.5.5 0 1 1-1 0V7H.5a.5.5 0 1 1 0-1H6z', fill: 'currentColor', fillRule: 'nonzero'
      })
    )
  );
};
/*eslint-enable */

exports.default = Expand;
//# sourceMappingURL=Expand.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Expand.js